<template>
  <div class='container'>
    <h1>Projects</h1>
    <p>Projects I participated in and/or developed.</p>

    <GitHubCard :info='dockerComposeHub' :loading='loading'>
      <p>
        {{ dockerComposeHub.description }}
        <a href='docker-compose.misec.top'>文档地址</a>.
      </p>
    </GitHubCard>

    <GitHubCard :info='AppleMonitor' :loading='loading'>
      <p>
        {{ AppleMonitor.description }}
      </p>
    </GitHubCard>
  </div>
</template>

<script>
import GitHubCard from '@/components/GitHubCard.vue'

export default {
  components: {
    GitHubCard,
  },
  data() {
    return {
      loading: true,
      dockerComposeHub: {
        stargazers_count: 0,
        forks_count: 0,
      },
      AppleMonitor: {
        stargazers_count: 0,
        forks_count: 0,
        description: '',
      },
    }
  },
  mounted() {

    const githubApiUrl = 'https://api.github.com/repos/MoshiCoCo'

    const dockerComposeHub = this.axios.get(`${githubApiUrl}/docker-compose-hub`)

    const AppleMonitor = this.axios.get(`${githubApiUrl}/Apple-Monitor`)

    this.axios
      .all([dockerComposeHub, AppleMonitor])
      .then(
        this.axios.spread((...resp) => {
          this.loading = false
          this.dockerComposeHub = resp[0].data
          this.AppleMonitor = resp[1].data
        }),
      )
      .catch(err => {
        this.loading = false
        // eslint-disable-next-line no-console
        console.error(err)
      })
  },
}


</script>

<style scoped>
.container .github-project-card:not(:last-child) {
  margin-bottom: 40px;
}
</style>
